import { render } from "./CouponIndex.vue?vue&type=template&id=dc1e5a60&scoped=true"
import script from "./CouponIndex.vue?vue&type=script&lang=js"
export * from "./CouponIndex.vue?vue&type=script&lang=js"

import "./CouponIndex.vue?vue&type=style&index=0&id=dc1e5a60&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1e5a60"]])

export default __exports__